<template>
  <div>
    <v-container fluid grid-list-sm>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-5" flat>
              <v-icon>mdi-format-align-justify</v-icon>
              <v-toolbar-title class="toolbar-title-2">{{ labels.otherDetailsTitle }}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <message :messages="messages"></message>
              <v-container fluid grid-list-sm>
                <v-layout row wrap align-center>
                  <v-flex sm4 md4 lg4 xs12>
                    <v-autocomplete
                      :items="policyHeaderParam.deptList"
                      v-model="mainForm.dept"
                      :label="labels.dept"
                      item-text="label"
                      item-value="value"
                      data-vv-name="dept"
                      :data-vv-as="labels.dept"
                      :error-messages="errors.collect('dept')"
                      :loading="initLoading"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex sm4 md4 lg4 xs12>
                    <v-text-field
                      v-model="mainForm.execICDesc"
                      :label="labels.execIC"
                      :error-messages="errors.collect('execIC')"
                      data-vv-name="execIC"
                      :data-vv-as="labels.execIC"
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm4 md4 lg4 xs12>
                    <v-text-field
                      v-model="mainForm.agtUsrId"
                      :label="labels.agtUsrId"
                      :error-messages="errors.collect('agtUsrId')"
                      data-vv-name="agtUsrId"
                      :data-vv-as="labels.agtUsrId"
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm4 md4 lg4 xs12>
                    <cal-picker v-model="mainForm.issDate" :label="labels.issDate"></cal-picker>
                  </v-flex>
                  <v-flex sm4 md4 lg4 xs12>
                    <cal-picker
                      v-model="mainForm.retroDate"
                      :label="labels.retroDate"
                      :data-vv-as="labels.retroDate"
                      data-vv-name="retroDate"
                      :error-messages="errors.collect('retroDate')"
                      v-validate="valRetroDate"
                      :loading="initLoading"
                    ></cal-picker>
                  </v-flex>
                  <v-flex sm1 md1 lg1 xs12>
                    <v-text-field
                      v-model="mainForm.maintPer"
                      :label="labels.maintPer"
                      :error-messages="errors.collect('maintPer')"
                      data-vv-name="maintPer"
                      :data-vv-as="labels.maintPer"
                      v-validate="'numeric|max:2'"
                      v-int-mask="{ intScale: 2 }"
                      type="tel"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm1 md1 lg1 xs12>
                    {{ labels.months }}
                  </v-flex>
                  <v-flex sm1 md1 lg1 xs12>
                    <v-text-field
                      v-model="mainForm.dliabPer"
                      :label="labels.dliabPer"
                      :error-messages="errors.collect('dliabPer')"
                      data-vv-name="dliabPer"
                      :data-vv-as="labels.dliabPer"
                      v-validate="'numeric|max:2'"
                      v-int-mask="{ intScale: 2 }"
                      type="tel"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm1 md1 lg1 xs12>
                    {{ labels.months }}
                  </v-flex>
                  <v-flex sm4 md4 lg4 xs12>
                    <v-text-field v-model="ipcInfo.ipcNoSeqNo" :label="labels.ipcNoSeqNo" disabled></v-text-field>
                  </v-flex>
                  <v-flex sm4 md4 lg4 xs12>
                    <v-text-field v-model="ipcInfo.ipcDate" :label="labels.ipcDate" disabled></v-text-field>
                    <!-- <v-subheader class="queryLabel">{{labels.ipcDate}}</v-subheader>
                    <div class="queryValue">{{formatDisplayDate(ipcInfo.ipcDate)}}</div> -->
                  </v-flex>
                  <v-flex sm4 md4 lg4 xs12>
                    <v-text-field v-model="ipcInfo.ipcStatus" :label="labels.ipcStatus" disabled></v-text-field>
                    <!-- <v-subheader class="queryLabel">{{labels.ipcStatus}}</v-subheader>
                    <div class="queryValue">{{ipcInfo.ipcStatus}}</div> -->
                  </v-flex>
                  <v-flex sm4 md4 lg4 xs12>
                    <v-text-field v-model="mainForm.progId" :label="labels.progID" disabled></v-text-field>
                    <!-- <v-subheader class="queryLabel">{{labels.ipcStatus}}</v-subheader>
                    <div class="queryValue">{{ipcInfo.ipcStatus}}</div> -->
                  </v-flex>
                  <v-flex xs12>
                    <v-divider class="mt-2"></v-divider>
                  </v-flex>
                  <v-flex xs12>
                    <v-toolbar dense color="grey lighten-4" flat>
                      <v-icon>mdi-history</v-icon>
                      <v-toolbar-title class="toolbar-title-2">Transaction History</v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-data-table :headers="headers" :items="items" class="elevation-1" hide-default-footer :loading="initLoading">
                      <template v-slot:item="row">
                        <tr>
                          <td>{{ row.item.name }}</td>
                          <td>{{ row.item.dateTime }}</td>
                          <td>{{ row.item.userId }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn class="mr-2" color="error" dark :loading="policy.saving" @click.prevent="doExit">
                      {{ labels.exit }}
                      <v-icon dark right>mdi-exit-to-app</v-icon>
                    </v-btn>
                    <v-btn class="mr-2" color="info" dark :loading="policy.saving" @click.prevent="doSave">
                      {{ labels.save }}
                      <v-icon dark right>mdi-content-save</v-icon>
                    </v-btn>
                    <v-btn class="mr-2" color="primary" dark :loading="policy.saving" @click.prevent="doProceed">
                      {{ labels.proceed }}
                      <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-dialog v-model="policy.saving" persistent width="300">
                  <v-card color="primary" dark>
                    <v-card-text>
                      Processing...
                      <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate, removeTime } from '@/utils/date'
import { POLICY_LIFECYCLE, POLICY_HEADER_TAB, POLICY_OTHER_DETALS, POLICY_RISK_TAB, POLICYGENERAL_LOAD_DATA } from '@/store/types'
import isAfter from 'date-fns/isAfter'
import clone from 'clone'
import { isEqual } from '@/utils/compare'

export default {
  data() {
    return {
      labels: {
        otherDetailsTitle: 'Other Details',
        issDate: 'Issue Date',
        retroDate: 'Retroactive Date',
        dept: 'Department',
        maintPer: 'Maintenance Period',
        months: 'Month(s)',
        dliabPer: 'Defect Liability',
        execIC: 'Executive In-charge',
        agtUsrId: 'Agency User ID',
        exit: 'Exit',
        reset: 'Reset',
        save: 'Save',
        proceed: 'Proceed',
        ipcNoSeqNo: 'IPC No./Seq No.',
        ipcDate: 'IPC Date',
        ipcStatus: 'IPC Status',
        progID: 'Program ID'
      },
      mainForm: {
        issDate: undefined,
        retroDate: undefined,
        dept: undefined,
        maintPer: undefined,
        dliabPer: undefined,
        execIC: undefined,
        agtUsrId: undefined,
        progId: undefined,
        execICDesc: undefined
      },
      policyHeaderParam: {
        perRetroDate: undefined,
        deptList: []
      },
      policy: {
        saving: false
      },
      headers: [
        { text: 'Action', align: 'left', value: 'name' },
        { text: 'Date/Time', align: 'left', value: 'date' },
        { text: 'User ID', align: 'left', value: 'usrid' }
      ],
      items: [],
      initLoading: false,
      proceedForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        mode: undefined
      },
      ipcInfo: {
        ipcNoSeqNo: undefined,
        ipcDate: undefined,
        ipcStatus: undefined
      }
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    valRetroDate() {
      return 'checkEndDate:' + this.polMaster.expDate
    }
  },
  methods: {
    doInit() {
      this.mainForm.issDate = this.polMaster.issDate
      this.mainForm.retroDate = this.polMaster.retroDate
      this.mainForm.dept = this.polMaster.dept
      this.mainForm.maintPer = this.polMaster.maintPer
      this.mainForm.dliabPer = this.polMaster.dliabPer
      this.mainForm.execIC = this.polMaster.execIC
      this.mainForm.agtUsrId = this.polMaster.agtUsrId
      this.mainForm.progId = this.polMaster.progId
      this.$set(this, 'items', [])
      this.fetchData()
    },
    async fetchData() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.otherDetails
      if (apiUrl) {
        try {
          this.initLoading = true
          const expand = {
            polType: this.polMaster.polType,
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data.departmentList) {
            this.$set(this.policyHeaderParam, 'deptList', result.data.departmentList)
          }

          if (result.data.perRetroDate) {
            this.policyHeaderParam.perRetroDate = false
          } else {
            this.policyHeaderParam.perRetroDate = true
          }

          if (result.data.execIC !== undefined) {
            this.mainForm.execIC = result.data.execIC
          }

          if (result.data.execICDesc !== undefined) {
            this.mainForm.execICDesc = result.data.execIC + ' - ' + result.data.execICDesc
          }

          if (this.polMaster.dept === '') {
            this.mainForm.dept = result.data.defaultPolType
          }

          if (result.data.polEntryInfoList) {
            result.data.polEntryInfoList.map((polEntryInfo) => {
              if (polEntryInfo.userId !== null && polEntryInfo.userId !== '' && polEntryInfo.userId !== undefined) {
                const convertPolEntryInfo = {
                  name: polEntryInfo.name,
                  dateTime: polEntryInfo.dateTime,
                  userId: polEntryInfo.userId.toUpperCase()
                }
                this.items.push(convertPolEntryInfo)
              }
            })
          } else {
            this.items = []
          }

          var ipcNo = result.data.ipcNo === null ? '' : result.data.ipcNo
          var ipcSeqNo = result.data.ipcSeqNo === null ? '' : result.data.ipcSeqNo
          this.ipcInfo.ipcNoSeqNo = ipcNo === '' ? ipcSeqNo : ipcNo + ' ' + ipcSeqNo
          this.ipcInfo.ipcDate = formatDisplayDate(result.data.ipcDate)
          this.ipcInfo.ipcStatus = result.data.ipcStatus

          this.initLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.initLoading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
      this.copymainForm = clone(this.mainForm)
    },
    doExit() {
      this.$router.push({ name: 'policyListing' })
    },
    doReset() {
      this.doInit()
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.policy.saving = true
          this.doPolMasterSave().then((success) => {
            if (success) {
              this.doProceedOtherDetails().then((success2) => {
                if (success2) {
                  this.$store.commit(POLICY_HEADER_TAB, 0)
                  this.$store.commit(POLICY_LIFECYCLE, 3)
                  this.$store.commit(POLICY_RISK_TAB, 0)
                  this.$router.push({ name: 'policyRisk' })
                } else {
                  this.policy.saving = false
                }
              })
            } else {
              this.policy.saving = false
            }
          })
        } else {
          this.policy.saving = false
          this.promptFieldCheck()
        }
      })
    },
    async doProceedOtherDetails() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.proceedOtherDetails
      if (apiUrl) {
        this.proceedForm.polNo = this.polMaster.polNo
        this.proceedForm.renCnt = this.polMaster.renCnt
        this.proceedForm.endtCnt = this.polMaster.endtCnt
        this.proceedForm.mode = this.$store.state.underwriting.policyMode
        try {
          const result = await this.$http.post(apiUrl, this.proceedForm)
          if (result.data) {
            const commitObject = {
              data: result.data
            }
            this.$store.commit(POLICYGENERAL_LOAD_DATA, commitObject)
            return true
          }
          return true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.policy.saving = true
          this.doPolMasterSave().then((success) => {
            if (success) {
              this.doProceedOtherDetails().then((success2) => {
                if (success2) {
                  this.$toast.success('Policy record successfully saved.')
                } else {
                  this.$toast.error('Failed saving policy record.')
                }
              })
            } else {
              this.$toast.error('Failed saving policy record.')
            }
            this.policy.saving = false
          })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPolMasterSave() {
      try {
        if (isEqual(this.mainForm, this.copymainForm) === true) {
          return true
        } else {
          this.$store.commit(POLICY_OTHER_DETALS, this.mainForm)
          const saveResult = await this.$store.dispatch('savePolMasterOtherDetails')
          if (saveResult) {
            this.copymainForm = clone(this.mainForm)
            return true
          } else {
            return false
          }
        }
      } catch (err) {
        return false
      }
    },
    async doValidateAllWarn() {
      return true
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    }
  },
  beforeMount() {
    this.doInit()
  },
  created() {
    // Local validator
    const valRetroDate = {
      getMessage: (field, args) => {
        return 'Cannot be later than Expiry Date (10109)'
      },
      validate: (value, args) => {
        if (value) {
          if (args === void 0) args = []
          var endDate = args[0]
          if (endDate) {
            return !isAfter(removeTime(value), removeTime(endDate))
          } else {
            return true
          }
        } else {
          return true
        }
      }
    }
    this.$validator.extend('checkEndDate', valRetroDate)
  },
  mixins: [MessageMixin]
}
</script>
